module.exports = __webpack_public_path__ + "media/favourite-aspects.d3d8ff93.mp4";